import { useEffect, useRef, useState } from "react";
import AdminFormLayout, { FormSection } from "../../components/common/form-layout/AdminFormLayout";
import { getApi, putApi } from "../../services/api/globalApi";

const path = "admin/settings/maintenance";

export default function MaintenanceSettings() {
  const [settings, setSettings] = useState(null);
  const [error, setError] = useState("");
  const [saving, setSaving] = useState(false);
  const [saved, setSaved] = useState(false);
  const [attempt, setAttempt] = useState(0);
  const inFlight = useRef(false);

  useEffect(() => {
    let active = true;
    setError("");
    getApi({ path }).then(response => {
      const value = response?.data?.result;
      if (typeof value?.enabled !== "boolean" || typeof value?.message !== "string") throw new Error("invalid settings");
      if (active) setSettings(value);
    }).catch(() => { if (active) setError("دریافت تنظیمات نگهداری انجام نشد."); });
    return () => { active = false; };
  }, [attempt]);

  const change = (field, value) => {
    setSaved(false);
    setSettings(current => ({ ...current, [field]: value }));
  };
  const save = async event => {
    event.preventDefault();
    if (!settings || inFlight.current) return;
    if (settings.enabled && !settings.message.trim()) {
      setError("برای فعال‌سازی حالت نگهداری، متن اصلی را وارد کنید.");
      return;
    }
    inFlight.current = true;
    setSaving(true); setSaved(false); setError("");
    try {
      const response = await putApi({ path, body: settings });
      setSettings(response.data.result);
      setSaved(true);
    } catch (_) {
      setError("ذخیره تنظیمات انجام نشد. دوباره تلاش کنید.");
    } finally {
      inFlight.current = false;
      setSaving(false);
    }
  };

  return <AdminFormLayout title="حالت نگهداری سایت (مینتنس)" description="هنگام به‌روزرسانی، متن دلخواه شما به بازدیدکنندگان نمایش داده می‌شود. پنل مدیریت و نتیجه پرداخت‌های قبلی در دسترس می‌مانند.">
    {error && <p role="alert" className="mb-4 text-red-700">{error} {!settings && <button type="button" onClick={() => setAttempt(value => value + 1)} className="mr-3 underline">تلاش دوباره</button>}</p>}
    {!settings && !error && <p role="status">در حال دریافت تنظیمات…</p>}
    <form onSubmit={save}>
      <fieldset disabled={!settings || saving}>
        <FormSection title="وضعیت و متن صفحه نگهداری">
          <label className="mb-6 flex items-center gap-3 font-medium text-slate-800 dark:text-white">
            <input type="checkbox" checked={settings?.enabled || false} onChange={event => change("enabled", event.target.checked)} className="h-5 w-5" />
            فعال‌سازی حالت نگهداری سایت
          </label>
          <label htmlFor="maintenance-message" className="mb-2 block font-medium text-slate-800 dark:text-white">متن اصلی صفحه نگهداری</label>
          <textarea id="maintenance-message" rows={6} maxLength={5000} required={settings?.enabled} value={settings?.message || ""} onChange={event => change("message", event.target.value)} className="admin-field block w-full" placeholder="متنی که بازدیدکنندگان هنگام نگهداری سایت می‌بینند…" />
          <p className="mt-2 text-sm text-slate-500">با فعال‌سازی، ثبت خرید و سایر تغییرات کاربران موقتاً متوقف می‌شود. تغییرات پس از ذخیره اعمال می‌شوند.</p>
        </FormSection>
        <FormSection title="پیش‌نمایش متن اصلی">
          <p className="whitespace-pre-wrap break-words rounded-xl bg-slate-50 p-5 leading-8 text-slate-700 dark:bg-slate-800 dark:text-slate-200">{settings?.message || "متن اصلی را وارد کنید."}</p>
        </FormSection>
        <button type="submit" className="mt-6 rounded-xl bg-blue-700 px-6 py-3 text-white disabled:opacity-50">{saving ? "در حال ذخیره…" : "ذخیره تنظیمات نگهداری"}</button>
      </fieldset>
      {saved && <p role="status" className="mt-4 text-green-700">تنظیمات نگهداری با موفقیت ذخیره شد.</p>}
    </form>
  </AdminFormLayout>;
}
